import { Controller } from "@hotwired/stimulus"

const cellValue = (cell) => {
  const text = cell.textContent.trim()
  const number = Number(text.replace(/[^0-9.-]/g, ""))
  return text !== "" && !Number.isNaN(number) ? number : text
}

const compare = (a, b) => {
  if (typeof a === "number" && typeof b === "number") return a - b
  return String(a).localeCompare(String(b))
}

export default class extends Controller {
  connect() {
    this.headers = Array.from(this.element.querySelectorAll("thead th"))
    this.headers.forEach((th) => {
      th.style.cursor = "pointer"
      th.addEventListener("click", this.sort)
    })
  }

  disconnect() {
    this.headers.forEach((th) => th.removeEventListener("click", this.sort))
  }

  sort = (event) => {
    const header = event.currentTarget
    const tbody = this.element.tBodies[0]
    const column = Array.from(header.parentNode.children).indexOf(header)
    const direction = header.dataset.sortDirection === "asc" ? "desc" : "asc"
    const rows = Array.from(tbody.rows)

    rows.sort((a, b) => {
      const result = compare(cellValue(a.cells[column]), cellValue(b.cells[column]))
      return direction === "asc" ? result : -result
    })

    rows.forEach((row) => tbody.appendChild(row))
    this.headers.forEach((th) => {
      delete th.dataset.sortDirection
      th.removeAttribute("aria-sort")
    })
    header.dataset.sortDirection = direction
    header.setAttribute("aria-sort", direction === "asc" ? "ascending" : "descending")
  }
}
